// ========================================================
// FILE: src/pages/Shop/Shop.jsx
// FULLY FIXED SHOP PAGE
// PRODUCT DETAILS OPEN ON CLICK
// ========================================================

import React, {
  useEffect,
  useState,
} from "react";

import {
  FiSearch,
  FiShoppingCart,
  FiClock,
  FiHeart,
} from "react-icons/fi";

import {
  useNavigate,
  useLocation,
} from "react-router-dom";

import { MagnifyingGlass } from "react-loader-spinner";

import ScrollToTop from "../ScrollToTop";

import Swal from "sweetalert2";

import api from "../../utils/api";

import "./ShopSidebar.css";

const BASE_URL =
  "https://api.freshcart4u.com";

function Shop() {

  const navigate =
    useNavigate();

  const location =
    useLocation();

  const [loaderStatus,
    setLoaderStatus] =
    useState(true);

  const [products,
    setProducts] =
    useState([]);

  const [allProducts,
    setAllProducts] =
    useState([]);

  const [selectedCategory,
    setSelectedCategory] =
    useState("");

  const [categories,
    setCategories] =
    useState([]);

  const [search,
    setSearch] =
    useState("");

  const [cart,
    setCart] =
    useState({});

  
const user =
  JSON.parse(localStorage.getItem("user") || "{}");

const userId =
  localStorage.getItem("userId") ||
  user._id;

const token =
  localStorage.getItem("token");
  /* ===================================================
      LOADER
  =================================================== */

  useEffect(() => {

    const timer =
      setTimeout(() => {

        setLoaderStatus(
          false
        );

      }, 1000);

    return () =>
      clearTimeout(timer);

  }, []);

  /* ===================================================
      IMAGE
  =================================================== */

  const getImage = (
    img
  ) => {

    if (!img) {

      return "https://via.placeholder.com/300";

    }

    if (
      img.startsWith(
        "http"
      )
    ) {

      return img;

    }

    return `${BASE_URL}${img}`;
  };

  /* ===================================================
      FETCH PRODUCTS
  =================================================== */

  const fetchProducts =
    async () => {

      try {

        const res =
          await api.get(
            "/api/products",
            {
              params: {
                page: 1,
                limit: 20000,
              },
            }
          );

        const list =
          res.data.products || [];

        setProducts(list);

        setAllProducts(list);

        const uniqueCats =
          [
            ...new Set(
              list
                .map(
                  (p) =>
                    p.category
                )
                .filter(Boolean)
            ),
          ];

        setCategories(
          uniqueCats
        );

      } catch (err) {

        console.log(
          "Product Error:",
          err
        );

      }
    };

  /* ===================================================
      FETCH CART
  =================================================== */

  const fetchUserCart =
    async () => {

      if (
        !token ||
        !userId
      )
        return;

      try {

        const res =
          await api.get(
            `/api/cart/${userId}`
          );

        const items =
          res.data.items || [];

        const cartMap =
          {};

        items.forEach(
          (item) => {

            const p =
              item.productId ||
              item.product;

            if (p) {

              const pid =
                p._id;

              if (
                cartMap[pid]
              ) {

                cartMap[pid] +=
                  item.quantity;

              } else {

                cartMap[pid] =
                  item.quantity;
              }
            }
          }
        );

        setCart(
          cartMap
        );

      } catch (err) {

        console.log(
          "Cart Error:",
          err
        );

      }
    };

  useEffect(() => {

    fetchProducts();

    fetchUserCart();

  }, []);

  /* ===================================================
      AUTO REFRESH CART
  =================================================== */

  useEffect(() => {

    const handleCart =
      () => {

        fetchUserCart();

      };

    window.addEventListener(
      "cartUpdated",
      handleCart
    );

    return () => {

      window.removeEventListener(
        "cartUpdated",
        handleCart
      );
    };

  }, []);

  /* ===================================================
      URL CATEGORY
  =================================================== */

  useEffect(() => {

    const params =
      new URLSearchParams(
        location.search
      );

    const cat =
      params.get(
        "category"
      );

    if (cat) {

      setSelectedCategory(
        cat
      );

    }

  }, [location.search]);

  /* ===================================================
      FILTER PRODUCTS
  =================================================== */

  useEffect(() => {

    let filtered =
      allProducts;

    if (
      selectedCategory
    ) {

      filtered =
        filtered.filter(
          (p) =>
            p.category
              ?.toLowerCase() ===
            selectedCategory.toLowerCase()
        );
    }

    if (
      search.trim()
    ) {

      filtered =
        filtered.filter(
          (p) =>
            p.name
              ?.toLowerCase()
              .includes(
                search.toLowerCase()
              ) ||

            p.category
              ?.toLowerCase()
              .includes(
                search.toLowerCase()
              )
        );
    }

    setProducts(
      filtered
    );

  }, [
    selectedCategory,
    allProducts,
    search,
  ]);

  /* ===================================================
      DISCOUNT
  =================================================== */

  const getDiscountPercent =
    (
      mrp,
      price
    ) => {

      if (
        !mrp ||
        mrp <= price
      ) {

        return 0;

      }

      return Math.round(
        (
          (mrp -
            price) /
          mrp
        ) * 100
      );
    };

  /* ===================================================
      OUT OF STOCK
  =================================================== */

  const isOutOfStock =
    (
      product
    ) => {

      if (
        product.stock ===
          undefined ||
        product.stock ===
          null
      ) {

        return false;

      }

      return (
        product.stock <= 0
      );
    };

  /* ===================================================
      UPDATE QUANTITY
  =================================================== */

  const updateQty =
    async (
      productId,
      change
    ) => {

      if (
        !token ||
        !userId
      ) {

        navigate(
          "/MyAccountSignIn"
        );

        return;
      }

      const currentQty =
        cart[
          productId
        ] || 0;

      const newQty =
        currentQty +
        change;

      /* REMOVE */

      if (
        newQty <= 0
      ) {

        try {

          await api.post(
            "/api/cart/remove",
            {
              userId,
              productId,
            }
          );

          setCart(
            (prev) => {

              const updated =
                {
                  ...prev,
                };

              delete updated[
                productId
              ];

              return updated;
            }
          );

          window.dispatchEvent(
            new Event(
              "cartUpdated"
            )
          );

        } catch (err) {

          console.log(
            err
          );

        }

        return;
      }

      /* LOCAL */

      setCart(
        (prev) => ({
          ...prev,
          [productId]:
            newQty,
        })
      );

      try {

        if (
          currentQty === 0 &&
          change === 1
        ) {

          await api.post(
            "/api/cart/add",
            {
              userId,
              productId,
              quantity: 1,
            }
          );

        } else {

          await api.post(
            "/api/cart/update",
            {
              userId,
              productId,
              quantity:
                newQty,
            }
          );
        }

        window.dispatchEvent(
          new Event(
            "cartUpdated"
          )
        );

      } catch (err) {

        console.log(
          "Update Error:",
          err
        );

        fetchUserCart();

        Swal.fire({
          icon: "error",
          title:
            "Cart update failed",
          timer: 1200,
          showConfirmButton:
            false,
        });

      }
    };

  /* ===================================================
      TOTAL ITEMS
  =================================================== */

  const totalItems =
    Object.values(
      cart
    ).reduce(
      (a, b) =>
        a + b,
      0
    );

/* ===================================================
    CART TOTAL + FREE DELIVERY
=================================================== */

const cartSubtotal =
  products.length > 0
    ? products.reduce((total, product) => {

        const qty =
          cart[product._id] || 0;

        return (
          total +
          Number(product.price || 0) *
          qty
        );

      }, 0)
    : 0;

const FREE_DELIVERY_LIMIT = 199;

const isFreeDelivery =
  cartSubtotal >= FREE_DELIVERY_LIMIT;

const amountForFreeDelivery =
  Math.max(
    0,
    FREE_DELIVERY_LIMIT - cartSubtotal
  );

  /* ===================================================
      UI
  =================================================== */

  return (

    <div className="modern-shop">

      {loaderStatus ? (

        <div className="loader-box">

          <MagnifyingGlass
            visible={true}
            height="100"
            width="100"
            color="#ffd600"
          />

        </div>

      ) : (

        <>

<ScrollToTop />

{/* HEADER */}


  <div className="top-header">
  <div className="search-bar">
    <FiSearch />

    <input
      type="text"
      placeholder='Search "Atta", "Milk", "Eggs"...'
      value={search}
      onChange={(e) => setSearch(e.target.value)}
    />
  </div>
</div>

<div className="shop-layout">

          {/* CATEGORY */}


<div className="shop-category-section">
      
<div className="shop-category-scroll">

      
<div
  className={`shop-category-item ${
    selectedCategory === ""
      ? "shop-active-cat"
      : ""
  }`}
  onClick={() => setSelectedCategory("")}
>
  <p>All Items</p>
</div>

        {categories.map((cat) => (

    
<div
  key={cat}
  className={`shop-category-item ${
    selectedCategory === cat
      ? "shop-active-cat"
      : ""
  }`}
  onClick={() => setSelectedCategory(cat)}
>
  <p>{cat}</p>
</div>

        ))}

      </div>


    </div>

    {/* RIGHT PRODUCTS */}

    
<div className="shop-products-section">

     
<h2 className="shop-catalog-title">

        

      </h2>

      
<div className="shop-products-grid">

        {products.map((p) => {

          const outOfStock =
            isOutOfStock(p);

          const discount =
            getDiscountPercent(
              p.mrp,
              p.price
            );

                  return (

                   
<div
  className="shop-product-card"
  key={p._id}
>

                      {/* DISCOUNT */}

                      {discount >
                        0 && (

                        <div className="discount-badge">

                          {
                            discount
                          }
                          % OFF

                        </div>

                      )}

                      {/* WISHLIST */}

                      
<div className="shop-wishlist-btn">

                        <FiHeart />

                      </div>

                      {/* IMAGE */}

                      <div
                        className="shop-product-image clickable-product"
                        onClick={() =>
                          navigate(
                            `/product/${p._id}`
                          )
                        }
                      >

                        <img
                          src={getImage(
                            p.images?.[0]
                          )}
                          alt={
                            p.name
                          }
                        />

                      </div>

                      {/* DELIVERY */}

                      
<div className="shop-delivery-box">

                        <FiClock />

                        10 min

                      </div>

                      {/* CATEGORY */}

                     
<span className="shop-product-category">

                        {
                          p.category
                        }

                      </span>

                      {/* NAME */}

                      <h4
                        className="clickable-product"
                        onClick={() =>
                          navigate(
                            `/product/${p._id}`
                          )
                        }
                      >

                        {p.name}

                      </h4>

                      {/* PRICE */}

                      
<div className="shop-price-row">

                        <div>

                          {p.mrp &&
                            p.mrp >
                              p.price && (

                             
<span className="shop-old-price">

                                ₹
                                {
                                  p.mrp
                                }

                              </span>

                            )}

                          <h3>

                            ₹
                            {
                              p.price
                            }

                          </h3>

                        </div>

                        {/* BUTTON */}

                        {outOfStock ? (

                          <button
                            className="shop-out-btn"

                          >

                            Out

                          </button>

                        ) : cart[
                            p._id
                          ] ? (

                          <div className="shop-qty-box">

                            <button
                              onClick={() =>
                                updateQty(
                                  p._id,
                                  -1
                                )
                              }
                            >

                              -

                            </button>

                            <span>

                              {cart[
                                p._id
                              ]}

                            </span>

                            <button
                              onClick={() =>
                                updateQty(
                                  p._id,
                                  1
                                )
                              }
                            >

                              +

                            </button>

                          </div>

                        ) : (

                          <button
                            className="shop-add-btn"
                            onClick={() =>
                              updateQty(
                                p._id,
                                1
                              )
                            }
                          >

                            ADD

                          </button>

                        )}

                      </div>

                    </div>

                  );
                }
              )}

            </div>

   </div>

</div>


{/* FLOATING CART */}

{totalItems > 0 && (

  <div
    className="shop-floating-cart"
    onClick={() =>
      navigate("/shopCart")
    }
  >

    {/* FREE DELIVERY MESSAGE */}

    <div
      className="shop-free-delivery-message"
      onClick={(e) =>
        e.stopPropagation()
      }
    >

      {isFreeDelivery ? (

        <>
          <span>
            🎉 FREE DELIVERY
          </span>

          <small>
            Up to 3 KM
          </small>
        </>

      ) : (

        <>
          <span>
            🚚 Add ₹{amountForFreeDelivery} more
          </span>

          <small>
            for FREE DELIVERY up to 3 KM
          </small>
        </>

      )}

    </div>


    {/* CART */}

    <div className="shop-cart-left">

      <strong>
        {totalItems}
      </strong>

      <small>
        Items
      </small>

    </div>


    <div className="shop-cart-right">

      <span>
        View Cart
      </span>

      <FiShoppingCart />

    </div>

  </div>

)}
          

        </>

      )}

    </div>

  );
}

export default Shop;